module.exports = __webpack_public_path__ + "img/8.a2029999.png";